/**
 * Whole years lived, as of `on` (default: now).
 *
 * Subtracting birth years is not this. It over-counts by one for everybody
 * whose birthday has not yet come round in the current year, which has two
 * consequences here beyond a cosmetic off-by-one:
 *
 *   - The 18+ check at client creation passed minors. Someone born late in
 *     the year reads as 18 on 1 January of the year they turn 18.
 *   - `age` is stored on the profile and feeds getBodyFatTable, whose bands
 *     step at 40 and 60. A man born in 1986 stored as 40 rather than 39 moves
 *     from the 18-39 band (healthy 9-20 %) to the 40-59 one (healthy 11-21 %),
 *     so a 20.5 % reading flips from "Overfat" to "Healthy".
 */
export function ageFromBirthDate(birthDate: Date, on: Date = new Date()): number {
  let age = on.getFullYear() - birthDate.getFullYear();
  const monthDelta = on.getMonth() - birthDate.getMonth();
  if (monthDelta < 0 || (monthDelta === 0 && on.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

/** The range a client may be created in. */
export const MIN_AGE = 18;
export const MAX_AGE = 120;

export const isCreatableAge = (age: number) => age >= MIN_AGE && age <= MAX_AGE;
